// @flow

import BaseChannel from './BaseChannel';

export default class JobEventsChannel extends BaseChannel {
  static channelName = "JobEventsChannel"
}
